import { useCallback, useState } from "react";
import ImagesListViewItem from "./ListView/ImagesListViewItem";
import { AddImagesModal } from "../AddImagesModal/AddImagesModal";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";
import { applyRotations } from "@coworker/apprestructured/src/task-management/util";

type AddImagesProps = {
  images: NewOrExistingFile[];
  onConfirmClick: (images: NewOrExistingFile[]) => void;
  disabled: boolean;
};

export const AddImages = ({
  images,
  onConfirmClick,
  disabled,
}: AddImagesProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState<NewOrExistingFile[]>([]);

  const handleListViewItemClick = useCallback(() => {
    setModalImages(images);
    setIsModalOpen(true);
  }, [images]);

  const handleAddImagesModalConfirmClick = useCallback(async () => {
    void (async () => {
      try {
        const processedImages = await applyRotations(modalImages);
        onConfirmClick(processedImages);
      } catch {
        // Prevent unhandled promise rejections when the modal consumer treats
        // onConfirmClick as a synchronous callback.
      }
    })();
  }, [modalImages, onConfirmClick]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <ImagesListViewItem
        images={images}
        onClick={handleListViewItemClick}
        disabled={disabled}
      />
      <AddImagesModal
        isOpen={isModalOpen}
        images={modalImages}
        onImagesChange={setModalImages}
        onClose={handleCloseModal}
        onConfirmClick={handleAddImagesModalConfirmClick}
      />
    </>
  );
};
